export default [
  {
    position: "absolute",
    top: 0.6,
    left: 0.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "navigatingP2.ttTextEight",
    hover: false,
    tooltipClass: "right",
    id: "SP_LeftHandMenu_Navigation_Homepage",
    index: 0,
  },
  {
    position: "absolute",
    top: 40,
    left: 8,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 18,
    tooltipText: "navigatingP2.ttTextOneB",
    hover: false,
    tooltipClass: "right",
    id: "SP_LeftHandMenu_Navigation_Menu_Planning",
    index: 1,
  },
  {
    position: "absolute",
    top: 42,
    left: 6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 12,
    tooltipText: "navigatingP2.ttTextTwo",
    hover: false,
    tooltipClass: "right",
    id: "SP_LeftHandMenu_Navigation_Menu_Analytics",
    index: 2,
  },
  {
    position: "absolute",
    top: 46,
    left: 6,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-bottom-left",
    isDialog: true,
    modal: false,
    mTitle: "navigatingP2.mTitleOne",
    mBody: "navigatingP2.mBodyOne",
    isVideo: true,
    videoThumb: "SP-Skills-Search-Thumb",
    videoURL: "SP-Skills-Search.mp4",
    vidIcon: true,
    id: "SP_LeftHandMenu_Video_Search",
    index: 3,
  },
  {
    position: "absolute",
    top: 4.4,
    left: 35.3,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "navigatingP2.ttTextThree",
    hover: false,
    id: "SP_LeftHandMenu_Navigation_PayBenefits",
    index: 4,
  },
  {
    position: "absolute",
    top: 4.4,
    left: 43.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "navigatingP2.ttTextFour",
    hover: false,
    id: "SP_LeftHandMenu_Navigation_Absence",
    index: 5,
  },
  {
    position: "absolute",
    top: 4.4,
    left: 50.1,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "navigatingP2.ttTextFive",
    hover: false,
    id: "SP_LeftHandMenu_Navigation_Performance",
    index: 6,
  },
  {
    position: "absolute",
    top: 4.4,
    left: 68.8,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 11,
    tooltipText: "navigatingP2.ttTextSix",
    hover: false,
    id: "SP_LeftHandMenu_Navigation_Hiring",
    index: 7,
  },
  {
    position: "absolute",
    top: 3.6,
    left: 98.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "navigatingP2.ttTextSeven",
    hover: false,
    tooltipClass: "left",
    id: "SP_LeftHandMenu_Navigation_TeamMember",
    index: 8,
  },
];
